import "../static/Section4.css";

export default function Section4() {
  return (
    <section className="section4">
      <div className="section4container">TODO</div>
    </section>
  );
}
